import config from '#config'
import {
	FlowStepData,
	FlowStepGroup,
	FlowStepSubGroup,
	getFlowSteps,
	mapModuleToModuleRoute,
} from '../pages/LandingPage/flowStepUtils'
import {
	AuthenticateSmartcheckSessionDto,
	ModuleDefinition,
	ModuleDefinitionType,
} from '../types/authenticateSmartcheckSessionDto'

export const FLOW_COMPLETED_STEP_INDEX = 100
export interface HeaderStepData {
	module?: ModuleDefinitionType
	displayNameKey?: string
	route: string
	stepGroup?: FlowStepGroup
}

export const mapToHeaderSteps = (flowStep: FlowStepData): HeaderStepData[] =>
	flowStep.modules.map((step) => ({
		module: step.module,
		displayNameKey: `header-${FlowStepSubGroup[flowStep.subGroup]}`,
		route: step.route,
		stepGroup: flowStep.group,
	}))

export const getHeaderSteps = async (
	caseSession: AuthenticateSmartcheckSessionDto,
) => {
	const flowSteps = await getFlowSteps(caseSession)

	return flowSteps.flatMap(mapToHeaderSteps)
}

export const getBudgetHelperHeaderSteps = (): HeaderStepData[] => {
	const questionnaireSteps: HeaderStepData[] = [
		{
			route: config.routeCodes.budgetHelperQuestionnaireCivilStatus,
		},
		{
			route: config.routeCodes.budgetHelperQuestionnaireMergedFinances,
		},
		{
			route: config.routeCodes.budgetHelperQuestionnaireSpouseConsent,
		},
		{
			route: config.routeCodes.budgetHelperQuestionnaireChildrenSelector,
		},
		{
			route: config.routeCodes.budgetHelperQuestionnaireChildrenAges,
		},
		{
			route: config.routeCodes.budgetHelperQuestionnaireBudgetFlowStart,
		},
	]
	const dataStep: HeaderStepData[] = mapModuleToModuleRoute(
		ModuleDefinition.Bank,
	)
	const budgetStep: HeaderStepData[] = mapModuleToModuleRoute(
		ModuleDefinition.Budget,
	)
	const sendEmailStep: HeaderStepData[] = mapModuleToModuleRoute(
		ModuleDefinition.BudgetConsumerEmail,
	)

	return [...questionnaireSteps, ...dataStep, ...budgetStep, ...sendEmailStep]
}

export const getStepIndexFromPathName = (
	pathName: string,
	headerSteps: HeaderStepData[],
	consumerInputsStepIndex?: number,
): number => {
	if (pathName === '/') {
		return -1
	}

	if (
		pathName === config.routeCodes.flowCompleted ||
		pathName === config.routeCodes.budgetConsumerEmailSent
	) {
		return FLOW_COMPLETED_STEP_INDEX
	}

	const activeStepIndex = headerSteps.findIndex((step) =>
		step.route.startsWith(pathName),
	)

	// Shift the index in the array by the current index of consumer inputs questionnaire
	if (pathName === config.routeCodes.consumerInputs) {
		return activeStepIndex + (consumerInputsStepIndex ?? 0)
	}

	return activeStepIndex
}
